import { ReactElement } from 'react';

import { Link } from 'react-router-dom';

import Fab from '@mui/material/Fab';
import Typography from '@mui/material/Typography';

import AddIcon from '@mui/icons-material/Add';

import GratiDirectory from '../components/common/GratiDirectory';
import GratiPageWrapper from '../components/common/GratiPageWrapper';
import GratiSystemError from '../components/common/GratiSystemError';
import Hourglass from '../components/common/Hourglass';
import CompetitionListItem from '../components/competition/CompetitionListItem';
import { useAuth } from '../contextProviders/AuthProvider';
import useCompetitions from '../dataHooks/useCompetitions';

export default function CompetitionLibraryPage(): ReactElement {
  const { isGod } = useAuth();
  const { competitions, isCompetitionsLoading, competitionsError } = useCompetitions();

  const Content = (): ReactElement => {
    if (isCompetitionsLoading) return <Hourglass />;
    if (competitionsError) return <GratiSystemError error={competitionsError} />;
    if (!competitions?.length) {
      return (
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            py: 2
          }}>No competitions in the library yet.
                  </Typography>
      );
    }
    return (
      <GratiDirectory>
        {competitions.map((competition) => (
          <CompetitionListItem
            key={competition.itemId}
            competition={competition}
            isDividerDisplayed
          />
        ))}
      </GratiDirectory>
    );
  };

  return (
    <GratiPageWrapper>
      <Content />
      {isGod && (
        <Fab
          variant="extended"
          color="primary"
          aria-label="create competition"
          component={Link}
          to="/competition-create"
        >
          <AddIcon />
          Add competition
        </Fab>
      )}
    </GratiPageWrapper>
  );
}
